import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Search from "../../Search/Search";
import Title from "../../Title/Title";

const Freeze_Accounts: React.FC = () => {
  return (
    <>
      <Row>
        <Col lg={4} md={4}>
          <Title title="تجميد حسابات" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="  رقم الحساب "
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> رقم الحساب </td>
                <td> الاسم والنسبة</td>
                <td> الاب </td>
                <td> الام </td>
                <td> الرقم الوطني </td>
                <td> العمليات </td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>0000</td>
                <td> الاحمد أحمد</td>
                <td>احمد</td>
                <td> خلود </td>
                <td> 2023 </td>
                <td>
                  <button className=" bg-[#efc5e6] p-2 rounded-2xl mx-2">
                    تفعيل الحساب
                  </button>
                  <button className=" bg-[#efc5e6] p-2 rounded-2xl">
                    تجميد الحساب
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
};

export default Freeze_Accounts;
